import moment from "moment";
export const STATUS = {
  not_sent: "Not sent",
  awaiting: "Sent — awaiting completion",
  guest_complete: "Completed by guest",
  manual_complete: "Manually marked complete",
};
export const date = (value) => value ? moment.utc(value).format("YYYY-MM-DD") : "";
export const timestamp = (value) => value ? moment.utc(value).local().format("MMM D, YYYY h:mm A") : "—";
export const defaults = () => ({ view: "weekly", date: moment().format("YYYY-MM-DD"), rental_id: "", survey_id: "", status: "" });
export const criteriaOf = (search) => {
  const input = Object.fromEntries(new URLSearchParams(search));
  const initial = defaults();
  // Old range links retain their first date as the navigation anchor.
  const candidate = input.date || input.start_date;
  const anchor = moment(candidate, "YYYY-MM-DD", true);
  const selected = anchor.isValid() ? anchor.startOf("day") : moment(initial.date);
  const view = input.view === "daily" ? "daily" : "weekly";
  return { view, date: selected.format("YYYY-MM-DD"),
    rental_id: input.rental_id || "", survey_id: input.survey_id || "", status: input.status || "",
    start_date: selected.clone().startOf(view === "weekly" ? "week" : "day").format("YYYY-MM-DD"),
    end_date: selected.clone().endOf(view === "weekly" ? "week" : "day").format("YYYY-MM-DD"),
  };
};
export const searchOf = (criteria) => {
  const params = new URLSearchParams();
  if (criteria.view === "daily") params.set("view", "daily");
  if (criteria.date !== defaults().date) params.set("date", criteria.date);
  for (const key of ["rental_id", "survey_id", "status"]) if (criteria[key]) params.set(key, criteria[key]);
  const query = params.toString();
  return query ? `?${query}` : "";
};
export const dateLabel = (criteria) => criteria.view === "daily"
  ? moment(criteria.date).format("ddd, MMM D, YYYY")
  : `${moment(criteria.start_date).format("MMM D")} – ${moment(criteria.end_date).format("MMM D, YYYY")}`;
export const bookingVersion = (row) => ({ check_in: date(row.check_in), check_out: date(row.check_out), schedule_version: row.schedule_version });
export const bookingUrl = (row) => `/guests?${new URLSearchParams({ search_term: row.reservation_id || "", preset: "custom", start_date: date(row.check_in), end_date: date(row.check_in), end_type: "check_in", filters: "standard", page: 0 })}`;
export const changedResponse = (row) => {
  const snapshot = row.context_snapshot;
  return !!snapshot && (date(snapshot.check_in) !== date(row.check_in) || date(snapshot.check_out) !== date(row.check_out) || snapshot.property !== row.property_name);
};
export const deliveryLabel = (row) => {
  if (row.provider_status) return `SMS: ${row.provider_status}${row.error_code ? ` (${row.error_code})` : ""}`;
  if (row.send_state === "queued") return `${row.channel === "email" ? "Email accepted" : "SMS queued"} — delivery unconfirmed`;
  if (row.send_state === "sent") return "Email sent — delivery unconfirmed";
  if (row.send_state === "failed") return "Delivery failed";
  if (row.send_state === "unknown") return "Send outcome unknown — check message history";
  if (row.send_state === "pending") return "Send in progress — do not resend";
  return row.legacy_send ? "Legacy send record — delivery unknown" : "No recorded send";
};

export const groupBookings = (rows = []) => {
  const groups = new Map();
  rows.forEach((row) => {
    const key = String(row.guest_reservation_id);
    if (!groups.has(key)) groups.set(key, { booking: row, surveys: [] });
    groups.get(key).surveys.push(row);
  });
  return [...groups.values()];
};
